import { SVGAttributes } from "react";

export const HashSymbolIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.978 1.21A1 1 0 106.022.79L5.334 4H3a1 1 0 100 2h1.906l-.857 4h-2.05a1 1 0 100 2H3.62l-.598 2.79a1 1 0 101.956.42L5.665 12H8.62l-.598 2.79a1 1 0 101.955.42l.688-3.21H13a1 1 0 000-2h-1.906l.857-4H14a1 1 0 100-2h-1.62l.597-2.79a1 1 0 10-1.955-.42L10.334 4H7.38l.598-2.79zM9.048 10l.858-4H6.95l-.857 4h2.954z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.978 5.21a1 1 0 00-1.956-.42L9.334 8H7a1 1 0 000 2h1.906l-.857 4H6a1 1 0 100 2h1.62l-.598 2.79a1 1 0 101.956.42L9.666 16h2.954l-.598 2.79a1 1 0 101.956.42l.688-3.21H17a1 1 0 100-2h-1.906l.857-4H18a1 1 0 100-2h-1.62l.598-2.79a1 1 0 00-1.956-.42L14.334 8H11.38l.598-2.79zm1.07 8.79l.858-4H10.95l-.857 4h2.955z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
HashSymbolIcon.displayName = "HashSymbolIcon";
